import React, { useMemo } from 'react';
import styles from './timestamped.module.css';
import { TimestampLine } from './timestamp-line';

const MIN_FONT_SIZE = 7;
const MAX_FONT_SIZE = 12;

export function Timestamped({
  children,
  name,
  fieldHeight,
}: {
  children: React.ReactNode;
  name: string;
  fieldHeight: number;
}) {
  // Approximate how the backend will render this font size in the document.
  // This is very basic. It does not attempt to truncate the text and uses
  // the height as a base for the font size.
  const fontSize = useMemo(() => {
    // Arbitrary value that replicates what the backend is doing
    const idealHeight = fieldHeight / 6;
    return Math.min(Math.max(idealHeight, MIN_FONT_SIZE), MAX_FONT_SIZE);
  }, [fieldHeight]);

  return (
    <div
      className={styles.timestampedSignature}
      style={
        { '--timestamp-font-size': `${fontSize}px` } as React.CSSProperties
      }
    >
      <div className={styles.timestampedSignatureContainer}>{children}</div>
      <TimestampLine>{name}</TimestampLine>
      <TimestampLine>MM/DD/YYYY hh:mm:ss UTC</TimestampLine>
    </div>
  );
}
